import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { dismissLinks } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function dismissBrokenLinks({
  accountId,
  model,
}: TVariables): Promise<TResult> {
  const response = await fetch(dismissLinks(accountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(model),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string | undefined;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  model: {
    LinkIds: Array<number> | undefined;
    IgnoreIsBroken: boolean;
  };
};

type TSnapshot = unknown;

function useDismissBrokenLinks(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const { accountId } = params;
    const response = await dismissBrokenLinks(params);
    if (response.Data) {
      queryClient.invalidateQueries(['getBrokenLinksForDismissal', accountId]);
      queryClient.invalidateQueries([
        'get_procedure_builder_procedures',
        accountId,
      ]);
    } else if (response.Errors) throw response;
    return response;
  });
}

export { useDismissBrokenLinks };
